import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const ClientReports = lazy(() => import('@/pages/client/ClientReports'));
const ClientBilling = lazy(() => import('@/pages/client/ClientBilling'));

export const clientRoutes: RouteObject[] = [
  {
    path: 'client',
    children: [
      {
        path: 'reports',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['client']}>
              <ClientReports />
            </ProtectedRoute>
          </Suspense>
        ),
      },
      {
        path: 'billing',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <ProtectedRoute allowedRoles={['client']}>
              <ClientBilling />
            </ProtectedRoute>
          </Suspense>
        ),
      },
    ],
  },
];
